import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import { MicrodataContext } from "config/contexts";
import generateRelativeHref from "utils/generateRelativeHref";

import styles from "./SummaryHeadline.css";

export default function SummaryHeadline({ headline, permalink }) {
  return (
    <MicrodataContext.Consumer>
      {microdata => (
        <h3
          className={styles.headline}
          itemProp={microdata ? "headline" : undefined}
        >
          <Link
            to={generateRelativeHref(permalink)}
            className={styles.headlineLink}
          >
            {headline}
          </Link>
        </h3>
      )}
    </MicrodataContext.Consumer>
  );
}

SummaryHeadline.propTypes = {
  headline: PropTypes.string.isRequired,
  permalink: PropTypes.string.isRequired,
};
